import { render } from "./ForgetPageST.vue?vue&type=template&id=f44fd80c&scoped=true"
import script from "./ForgetPageST.vue?vue&type=script&lang=js"
export * from "./ForgetPageST.vue?vue&type=script&lang=js"

import "./ForgetPageST.vue?vue&type=style&index=0&id=f44fd80c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f44fd80c"]])

export default __exports__